// const FARMIGO_PROPERTY_ID = 'UA-8893503-13';
const FARMIGO_GA4_ID = 'G-GRN3EZMZNW';

const Dimensions = {
    FARM_NAME: "dimension1",
    SEASON_NAME: "dimension2",
    USER_KEY: "dimension3",
    MODULE: "dimension4",
};

let sendToFarm = false;

export const initializeGoogleAnalytics = (farmTrackingId, farmName, seasonName, webSiteUrl) => {
    // ga('create', FARMIGO_PROPERTY_ID, 'auto');
    gtag('config', FARMIGO_GA4_ID);
    if (farmTrackingId && farmTrackingId !== '' && farmTrackingId.startsWith('G')) {
        const domain = webSiteUrl.split('/')[2].split('.');
        // ga('create', farmTrackingId, 'auto', 'farmTracker', {allowLinker: true});
        // ga('farmTracker.require', 'linker');
        // ga('farmTracker.linker:autoLink', [domain[domain.length - 2] + '.' + domain[domain.length - 1]]);
        gtag('config', farmTrackingId, {
            'linker': {
                'domains': [[domain[domain.length - 2] + '.' + domain[domain.length - 1]]]
            }
        });
        sendToFarm = true;
    }
    // ga('set', Dimensions.FARM_NAME, farmName);
    // ga('set', Dimensions.SEASON_NAME, seasonName);
    // let val1 = {};
    // val1[Dimensions.FARM_NAME] = farmName;
    // gtag('set', val1);
    // let val2 = {};
    // val2[Dimensions.SEASON_NAME] = seasonName;
    // gtag('set', val2);
};

export const sendGAEvent = (category, action, label, value) => {
    // ga('send', 'event', category, action, label, value);
    gtag('event', action, {'event_category': category, 'event_label': label, 'value': value, 'send_to': FARMIGO_GA4_ID});
    //For now do not send events to Farm
    // if (sendToFarm)
    //     ga('farmTracker.send', 'event', category, action, label, value);
};

export const sendGAPageView = (pageUrl) => {
    // setModule(pageUrl);
    // ga('send', 'pageview', pageUrl);
    gtag('event', 'page_view', {'page_path': pageUrl});
    // if (sendToFarm)
    //     ga('farmTracker.send', 'pageview', pageUrl);
};

export const setGAUserId = (key) => {
    // ga('set', 'userId', key);
    // ga('set', Dimensions.USER_KEY, key);
    // gtag('set', {'user_id': key});
    // let val = {};
    // val[Dimensions.USER_KEY] = key;
    // gtag('set', val);
};

function setModule(pageUrl) {
    // let module = pageUrl.split('/')[1];
    // ga('set', Dimensions.MODULE, module.charAt(0).toUpperCase() + module.slice(1));
    // let val = {};
    // val[Dimensions.MODULE] = module.charAt(0).toUpperCase() + module.slice(1);
    // gtag('set', val);

}



// WEBPACK FOOTER //
// ./src/common/analytics.js